export type Callback<T> = (data: T) => void;

type Envelope<T> = {
    __psb: true;
    channel: string;
    event: string;
    senderId: string;
    payload: T;
};

export class PubSubBroadcast<T> {
    private subscribers = new Set<Callback<T>>();
    private bc: BroadcastChannel | null = null;
    private senderId = crypto.randomUUID();

    constructor(private channelName: string, private eventName: string) {
        // BroadcastChannel existe en la mayoría de browsers modernos
        if (typeof BroadcastChannel !== "undefined") {
            this.bc = new BroadcastChannel(channelName);
            this.bc.onmessage = (ev: MessageEvent) => {
                const msg = ev.data as Envelope<T>;
                if (!msg?.__psb) return;
                if (msg.channel !== channelName) return;
                if (msg.event !== eventName) return;

                // Evita re-procesar lo que yo mismo envié (por si un browser lo re-broadcast)
                if (msg.senderId === this.senderId) return;

                this.emitLocal(msg.payload);
            };
        }
    }

    subscribe(cb: Callback<T>) {
        this.subscribers.add(cb);
        return () => this.subscribers.delete(cb);
    }

    publish(data: T) {
        this.emitLocal(data);

        if (this.bc) {
            const msg: Envelope<T> = {
                __psb: true,
                channel: this.channelName,
                event: this.eventName,
                senderId: this.senderId,
                payload: data,
            };
            this.bc.postMessage(msg);
        }
    }

    close() {
        this.bc?.close();
        this.bc = null;
        this.subscribers.clear();
    }

    private emitLocal(data: T) {
        this.subscribers.forEach((cb) => cb(data));
    }
}